//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../Annotations/Annotations.BendTableSettingsBuilder.js";
import "../Annotations/Annotations.HoleTableSettingsContentBuilder.js";
import "../Annotations/Annotations.HoleTableSettingsFormatBuilder.js";
import "../Annotations/Annotations.HoleTableSettingsHoleFiltersBuilder.js";
import "../Annotations/Annotations.HoleTableSettingsLabelBuilder.js";
import "../Annotations/Annotations.PartFamilyTableSettingsBuilder.js";
import "../Annotations/Annotations.PartsListBuilder.js";
import "../Annotations/Annotations.TableCellStyleBuilder.js";
import "../Annotations/Annotations.TableColumnSettingsBuilder.js";
import "../Annotations/Annotations.TableCommonSortingBuilder.js";
import "../Annotations/Annotations.TableSectionStyleBuilder.js";
import "../Annotations/Annotations.TabularNoteStyleBuilder.js";
let d=[[[1,"BendTable",0,"Annotations.BendTableSettingsBuilder",0],[1,"HoleTableContent",0,"Annotations.HoleTableSettingsContentBuilder",0],[1,"HoleTableFormat",0,"Annotations.HoleTableSettingsFormatBuilder",0],[1,"HoleTableHoleFilters",0,"Annotations.HoleTableSettingsHoleFiltersBuilder",0],[1,"HoleTableLabel",0,"Annotations.HoleTableSettingsLabelBuilder",0],[0,"HoleTableWorkflow",0,"Annotations.HoleTableSettingsWorkflowBuilder",0],[1,"PartFamilyTable",0,"Annotations.PartFamilyTableSettingsBuilder",0],[1,"PartsListBuilder",0,"Annotations.PartsListBuilder",0],[1,"TableCellStyle",0,"Annotations.TableCellStyleBuilder",0],[1,"TableColumnSettingsBuilder",0,"Annotations.TableColumnSettingsBuilder",0],[1,"TableCommonSorting",0,"Annotations.TableCommonSortingBuilder",0],[1,"TableSectionStyle",0,"Annotations.TableSectionStyleBuilder",0],[1,"TabularNoteStyle",0,"Annotations.TabularNoteStyleBuilder",0]],[],[]];
SPLM.Annotations.TableStyleBuilder = class extends SPLM.Annotations.StyleBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.TableStyleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;